import {
  MedRecSwitch,
  Promotion,
  SearchHeader,
  StoreLocator,
} from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderWithCenteredLogoAndLocatorFixDesktop = () => (
  <>
    <HeaderRow borderless differentBackground type="custom">
      <HeaderSection justify="center">
        <StoreLocator />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow borderless fullWidth type="flat">
      <Promotion location="header" />
    </HeaderRow>
    <HeaderRow>
      <HeaderSection justify="start">
        <HeaderNav />
      </HeaderSection>
      <HeaderSection justify="center">
        <HeaderLogo center fixHeight fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <SearchHeader withEmbeddedInput />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
        <MedRecSwitch compact />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithCenteredLogoAndLocatorFixDesktop };
